module.exports = __webpack_public_path__ + "static/img15-2196bcb602b968083d80d8a454d03cd5.jpg";